"use strict";

(function (Drupal) {
  Drupal.behaviors.hero = {
    attach: function attach(context, settings) {
      // There is only one hero on the page so we don't need `querySelectorAll`.
      var hero = context.querySelector('.hero--component');
      if (!hero) {
        return;
      }
      var timer;
      var body = document.body;
      var header = context.querySelector('.header--wrapper');
      var scrollOffset = 1;
      var headerOffset = 200;
      var classes = {
        active: 'js-slide-is-active',
        hero: 'js-hero-is-scrolled',
        paused: 'js-video-is-paused',
        processed: 'js-hero-is-processed',
        playing: 'js-video-is-playing'
      };

      /* Add classes to show the hero expanding */
      var heroExpansion = function heroExpansion() {
        // We immediately alter the appearance of the header on scroll.
        if (window.pageYOffset >= scrollOffset) {
          body.classList.add(classes.hero);
          // Use GSAP to fade the header as the image expands into it.
          if (!hero.classList.contains(classes.processed)) {
            gsap.to(header, {
              duration: 0.25,
              autoAlpha: 0,
              height: 0
            });
            hero.classList.add(classes.processed);
          }
        } else {
          // Reverse the header fade.
          body.classList.remove(classes.hero);
          hero.classList.remove(classes.processed);
          gsap.to(header, {
            duration: 0.25,
            autoAlpha: 1,
            height: 'auto'
          });
        }

        // When we're 200px into our image we need to reverse the header fade.
        // Otherwise when the sticky nav comes in the header is empty.
        if (window.pageYOffset >= headerOffset) {
          gsap.to(header, {
            duration: 0.25,
            autoAlpha: 1,
            height: 'auto'
          });
        }
      };

      /* Load the hero gradient if it exists */
      var heroManipulation = function heroManipulation() {
        var slides = hero.querySelectorAll('.paragraph--type--hero-slide');
        slides.forEach(function (slide) {
          // If the slide has a color we need to override the gradient color.
          if (slide.hasAttribute('data-color')) {
            // We get the color data and then convert it to rgb.
            var hex = slide.getAttribute('data-color');
            var color = Drupal.behaviors.dart_utils.hexToRgb(hex);
            var gradient = slide.querySelector('.gradient');
            // We do this with setAttribute instead of style = bc the template literal
            // was getting weird the other way.
            gradient.setAttribute('style', "background-image: linear-gradient(180deg, rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", 0) 2%, rgba(").concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", 0.7) 57%)"));
          }
        });
      };

      /* Load the hero video if it exists */
      var heroVideo = function heroVideo() {
        var video = hero.querySelector('.video__wrap');
        if (!video) {
          return;
        }
        var slide = hero.querySelector('.paragraph--type--hero-slide');
        Drupal.behaviors.dart_utils.loadHeroVideo(slide);
      };

      // A good way to debounce scroll without killing performance or FE cleanliness.
      // From https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance.
      window.addEventListener('scroll', function () {
        if (timer) {
          this.cancelAnimationFrame(timer);
        }
        timer = this.requestAnimationFrame(heroExpansion);
      }, false);
      heroManipulation();
      heroVideo();
    }
  };
})(Drupal);